import { Box, Paper } from '@mui/material';
import ErrorBoundaryWrapper from 'components/ErrorBoundaryWrapper';
import Promotions from 'pages/PosSettings/Promotions/Promotions';

const PromotionsPage = () => (
  <Box>
    <ErrorBoundaryWrapper>
      <Paper className="order-content">
        <Box sx={{ p: 2 }}>
          <Promotions />
        </Box>
      </Paper>
    </ErrorBoundaryWrapper>
  </Box>
);

export default PromotionsPage;
